<template>
  <div :class="[$shTemplateStyle.headerItemContainer]">
    <div :class="$shTemplateStyle.label">{{ $t("focus") }}:</div>

    <div :class="$style.selector">
      <div v-if="isSingleGroup">
        {{ groupOptions[0]?.label }}
      </div>

      <UtilInput
        v-else
        placeholder="Select group"
        size="xs"
        :isDropDown="true"
        :showDropdownDefault="false"
        :showLabel="false"
        :dropdownOptions="groupOptions"
        boxBg="#ffffff"
        :value="selectedGroupId"
        @update:value="selectedGroupId = $event"
      />
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/FocusGroupBox.module.css";
import secondaryHeaderTemplateStyles from "@/css/SecondaryHeaderTemplate.module.css";
import UtilInput from "../util/UtilInput.vue";
import { defineProps, computed, ref, watch } from "vue";
import { useGameGroupStore } from "@/stores/game/gameGroupStore";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const $style = styles;
const $shTemplateStyle = secondaryHeaderTemplateStyles;

const gameGroupStore = useGameGroupStore();

const props = defineProps({
  groups: {
    type: Array,
    required: true,
  },
});

const isSingleGroup = computed(() => (props.groups || []).length === 1);

const groupOptions = computed(() =>
  (props.groups || []).map((group, index) => {
    const displayName = getGroupDisplayName(group, index, t);

    return {
      id: Number(group.id),
      name: displayName,
      label: displayName,
      selectionValue: Number(group.id),
    };
  })
);

const selectedGroupId = ref(null);

watch(
  groupOptions,
  (opts) => {
    if (!opts.length) {
      selectedGroupId.value = null;
      gameGroupStore.setCurrentGroupId(null);
      return;
    }

    const currentId = Number(gameGroupStore.currentGroupId);
    const currentStillExists = opts.some(
      (o) => Number(o.id) === currentId
    );

    const nextId = currentStillExists
      ? currentId
      : Number(opts[0].id);

    selectedGroupId.value = nextId;
    gameGroupStore.setCurrentGroupId(nextId);
  },
  { immediate: true }
);

watch(selectedGroupId, (newVal) => {
  if (!newVal) return;

  gameGroupStore.setCurrentGroupId(Number(newVal));
});
</script>

<style scoped></style>